var Campaigns = require('scripts/entities/collections/campaigns');
module.exports = new Campaigns([], {url: '/campaigns', sort: false, filterStates: globalCh.request('filter-state')});